import jwt_decode from 'jwt-decode';
import cookie from 'react-cookies';

type cookieNameType = 'localhost-biocertica' | 'dev-biocertica' | 'biocertica';

export const COOKIE_NAME: cookieNameType =
    window.location.hostname === 'localhost'
        ? 'localhost-biocertica'
        : window.location.hostname === 'dev-portal.biocertica.com'
        ? 'dev-biocertica'
        : 'biocertica';

const COOKIE_DOMAIN = 'biocertica.com';

class CookieService {
    setCookie(cValue: string, durationDays: number) {
        const d = new Date();
        d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);

        if (window.location.hostname === 'localhost') {
            cookie.save(`${COOKIE_NAME}`, `${cValue}`, { path: '/', expires: d });
        } else {
            cookie.save(`${COOKIE_NAME}`, `${cValue}`, {
                path: '/',
                expires: d,
                domain: `${COOKIE_DOMAIN}`,
                secure: true,
            });
        }
    }

    getCookie() {
        return cookie.load(`${COOKIE_NAME}`) || null;
    }

    removeCookie() {
        if (window.location.hostname === 'localhost') {
            cookie.remove(`${COOKIE_NAME}`, { path: '/' });
        } else {
            cookie.remove(`${COOKIE_NAME}`, { path: '/', domain: `${COOKIE_DOMAIN}` });
        }
    }

    getScope(token: string): any {
        const decoded: any = jwt_decode(token);
        const scope = decoded?.scope || '';

        return scope;
    }
}

export const cookieService = new CookieService();
